import { render, staticRenderFns } from "./DisciplineInformationForm.vue?vue&type=template&id=e50cb73c"
import script from "./DisciplineInformationForm.vue?vue&type=script&lang=js"
export * from "./DisciplineInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports